import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// tslint:disable-next-line:max-line-length
import { BatchApprovalNextStepsComponent } from '@features/batches/@shared/modals/batch-approval-next-steps/batch-approval-next-steps.component';
// tslint:disable-next-line:max-line-length
import { BatchDeleteConfirmationComponent } from '@features/batches/@shared/modals/batch-delete-confirmation/batch-delete-confirmation.component';
import { BatchRejectComponent } from '@features/batches/@shared/modals/batch-reject/batch-reject.component';
// tslint:disable-next-line:max-line-length
import { BatchRequestSubmissionComponent } from '@features/batches/@shared/modals/batch-request-submission/batch-request-submission.component';
// tslint:disable-next-line:max-line-length
import { FillSiteApprovalGrantComponent } from '@features/batches/@shared/modals/fill-site-approval-grant/fill-site-approval-grant.component';
// tslint:disable-next-line:max-line-length
import { FillSiteQpBatchApprovalConfirmationComponent } from '@features/batches/@shared/modals/fill-site-qp-batch-approval-confirmation/fill-site-qp-batch-approval-confirmation.component';
// tslint:disable-next-line:max-line-length
import { FillSiteQpBatchApprovalFormComponent } from '@features/batches/@shared/modals/fill-site-qp-batch-approval-form/fill-site-qp-batch-approval-form.component';
// tslint:disable-next-line:max-line-length
import { FillSiteQpBatchApprovalWarningComponent } from '@features/batches/@shared/modals/fill-site-qp-batch-approval-warning/fill-site-qp-batch-approval-warning.component';
import { ForwardToTpqpFormComponent } from '@features/batches/@shared/modals/forward-to-tpqp-form/forward-to-tpqp-form.component';
import { SiteCommonModule } from '@widgets/site-common/site-common.module';
import { DatePipe } from '@widgets/ui-common/pipes/date/date.pipe';
import { BatchProgressComponent } from './components/batch-progress/batch-progress.component';
import { BatchProgressModule } from './components/batch-progress/batch-progress.module';
import { ExportToExcelComponent } from './components/export-to-excel/export-to-excel.component';
import { ApproveExtraLoadModule } from './components/load-weight-billing/load-details/approve-extra-load/approve-extra-load.module';
import { ExtraLoadModalModule } from './components/load-weight-billing/load-details/extra-load-modal/extra-load-modal.module';
import { LoadDetailsComponent } from './components/load-weight-billing/load-details/load-details.component';
import { WeightDetailsComponent } from './components/load-weight-billing/weight-details/weight-details.component';
import { QpAssignmentComponent } from './components/qp-assignment/qp-assignment.component';
import { QpCardComponent } from './components/qp-assignment/qp-card/qp-card.component';
import { TpqpBatchApprovalFormComponent } from './modals/tpqp-batch-approval-form/tpqp-batch-approval-form.component';

@NgModule({
  declarations: [
    QpAssignmentComponent,
    QpCardComponent,
    LoadDetailsComponent,
    WeightDetailsComponent,
    ExportToExcelComponent,
    BatchRejectComponent,
    BatchApprovalNextStepsComponent,
    FillSiteApprovalGrantComponent,
    FillSiteQpBatchApprovalWarningComponent,
    FillSiteQpBatchApprovalFormComponent,
    FillSiteQpBatchApprovalConfirmationComponent,
    ForwardToTpqpFormComponent,
    TpqpBatchApprovalFormComponent
  ],
  imports: [SiteCommonModule, RouterModule, BatchProgressModule, ExtraLoadModalModule, ApproveExtraLoadModule],
  exports: [
    QpAssignmentComponent,
    QpCardComponent,
    LoadDetailsComponent,
    WeightDetailsComponent,
    BatchProgressComponent,
    ExportToExcelComponent,
    TpqpBatchApprovalFormComponent,
    BatchProgressModule,
    ExtraLoadModalModule
  ],
  entryComponents: [
    BatchRequestSubmissionComponent,
    BatchDeleteConfirmationComponent,
    BatchApprovalNextStepsComponent,
    FillSiteApprovalGrantComponent,
    ForwardToTpqpFormComponent,
    TpqpBatchApprovalFormComponent
  ],
  providers: [DatePipe]
})
export class SharedModule {}
